import React from "react";
import {connect} from "react-redux";
import {Redirect, RouteComponentProps} from "react-router";
import {Dispatch} from "redux";
import {t} from "../i18n";
import {Settings, UserLevelView} from "../http/protocol";
import {fetchSettings} from "../settings/SettingsActions";
import {fetchUserLevelView} from "../user/UserActions";
import ContentfulClientService from "../contenful/ContentfulClientService";
import {AppState} from "../RootReducer";
import {BLOCKS} from '@contentful/rich-text-types';
import {fetchUserLevelsPage} from "../contenful/ContentfulActions";
import {getContainer} from "../ioc/IOCSetup";
import "./UserLevel.scss";
import {ProgressBar} from "react-bootstrap";
import {AccountCard} from "../ui/AccountUI";
import {renderContentAsComponent} from "../contentutils";


export const richTextOptions = {
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node:any) => {
            const { title, description, file } = node.data.target.fields;
            const mimeType = file.contentType;
            const mimeGroup = mimeType.split('/')[0];

            if(mimeGroup == 'image') {
                return <img
                    title={ title ? title : null}
                    alt={description ?  description : "info"}
                    src={file.url}
                />;
            } else {
                return <span style={{backgroundColor: 'red', color: 'white'}}> {mimeType} embedded asset </span>;
            }
        }
    }
};

export class UserLevel extends React.Component<AllProps, { entries? : any[], loading : boolean, levelsInfoMessege : boolean }>{
    service : ContentfulClientService;
    constructor(props : AllProps) {
        super(props);
        this.state = { loading : true, levelsInfoMessege: false }
        this.service = getContainer().getContentfulClientService();
    }

    componentDidMount(): void {
        window.scroll(0,0)
        this.props.fetchUserLevelView && this.props.fetchUserLevelView()
        this.loadContent();

        if(this.props.settings == undefined) {
            if(this.props.fetchSettings) {
                this.props.fetchSettings();
            }
        }
    }

    componentDidUpdate(prevProps: AllProps): void {
        if(this.props.lng && this.props.lng != prevProps.lng) {
            this.loadContent();
        }
    }

    loadContent() {
        fetchUserLevelsPage(this.props.lng).then(i => {
            this.setState({ entries : i, loading : false });
            if(i.length == 0) {
                this.setState({ levelsInfoMessege: true })
            }
        });
    }
    renderInformation() {
        const data = this.state.entries && this.state.entries.length > 0 && this.state.entries[0]
        return <div className="info-container">
                <h1 className="title">{t("userLevel.benefits")}</h1>
            {renderContentAsComponent(data && data.information as any, richTextOptions)}
        </div>
    }
    render () {
        let settings = this.props.settings;
        let showUserLevel = settings && settings.showUserLevel

        if(!this.props.loggedIn) {
            return <Redirect to={"/"} />
        }
        if(!showUserLevel) {
            return <Redirect to={"/"} />
        }

        const userLevel = this.props.userLevelView
        const currentLevel : number | undefined = userLevel && userLevel.currentLevel
        const nextLevel = userLevel && userLevel.nextLevelName
        const nextLevelPercentage : number | undefined = userLevel && userLevel.nextLevelProgressionPercentage
        const data = this.state.entries && this.state.entries.length > 0 && this.state.entries[0]
        const icons = data && data.icons

        return (
            <div className={"content-padding"}>
                    <h4 className={"section"}>
                        {t("userLevel.vipLevel")}
                    </h4>
                    <AccountCard className={`user-level`}>
                        {nextLevel &&
                            <div className="progress-container">
                            <div className="level-title">
                                <div className="level-icon">{icons && icons.map((icon: any, idx: number) => {
                                    if(!icon.file && icon.fields) {
                                        icon = icon.fields; // strapi/contentful difference
                                    }
                                    if(idx === currentLevel) {
                                        return <img className="icon" key={idx} src={icon && icon.file && icon.file.url} />
                                    }
                                })}
                                </div>
                                {t(`userLevel.name.${userLevel && userLevel.currentLevelName}`)}
                            </div>
                            <div className={"vip-level-progress"}>
                                <div className="next-level">
                                    <span className="title">{nextLevel && t(`userLevel.nextLevelTitle`)}</span>
                                </div>
                                <ProgressBar animated now={nextLevelPercentage} />
                                <div className="level-next-icon">{icons && icons.map((icon: any, idx: number) => {
                                        if(currentLevel != undefined) {
                                            if(!icon.file && icon.fields) {
                                                icon = icon.fields;
                                            }
                                            if(idx === (currentLevel+1)) {
                                                return <img className="icon" key={idx} src={icon && icon.file && icon.file.url} alt={icon && icon.title ? icon.title : 'level-icon'}/>
                                            }
                                        }
                                    })}
                                </div>
                                <div className="level-next-name name">
                                    <span>{nextLevel && t(`userLevel.name.${nextLevel}`)}</span>
                                </div>
                            </div>
                        </div>}
                        {this.renderInformation()}
                        {this.state.levelsInfoMessege && <div>{t("userLevel.no-level-info")}</div>}
                    </AccountCard>

            </div>
        )
    }
}

type AllProps = Props & PropsFromState;


interface Props extends RouteComponentProps<{section?: string, page? : string}> {
    loggedIn?: boolean;
    settings?: Settings;
    userLevelView?: UserLevelView;
    fetchSettings: typeof fetchSettings;
    fetchUserLevelView?: typeof fetchUserLevelView;
}

interface PropsFromState {
    lng: string;
}

const mapStateToProps = ({settings, user, contentful} : AppState) => {
    return {
        settings: settings.settings,
        loggedIn: user.user && user.user.loggedIn,
        userLevelView: user && user.userLevelView,
        lng: getContainer().getSettingsService().getActiveLocale().code,

    }
};

const dispatchToProps = (dispatch : Dispatch) => (
    {
        fetchUserLevelView : ()=>dispatch(fetchUserLevelView() as any)
    }
);

export default connect(mapStateToProps, dispatchToProps)(UserLevel)
